import timezones from 'timezones-list'

export const TimeZoneDropDownOptions = timezones.map((it: any) => ({
  itemId: it.tzCode,
  text: it.label,
  type: 'item',
}))
